export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./full-version.vue?vue&type=template&id=25da12a8&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/full-version.vue?vue&type=template&id=25da12a8&
// module id = 1643
// module chunks = 0